import { Route } from '@angular/router';
import { AppRoutingPaths } from '../app-routing.enums';

export class BusinessAccountRoutes {
  public static readonly ROUTES: Route[] = [
    {
      path: AppRoutingPaths.Empty,
      loadComponent: () =>
        import('../business-account/pages/business-account.component').then((c) => c.BusinessAccountComponent)
    },
    {
      path: AppRoutingPaths.DocumentUpload,
      loadComponent: () =>
        import('../documents-upload/pages/documents-upload.component').then((c) => c.DocumentsUploadComponent)
    },
    {
      path: AppRoutingPaths.MerchantSaved,
      loadComponent: () => import('../success-pages/saved-page/saved-page.component').then((c) => c.SavedPageComponent)
    },
    {
      path: AppRoutingPaths.ThankYou,
      loadComponent: () =>
        import('../success-pages/thank-you-page/thank-you-page.component').then((c) => c.ThankYouPageComponent)
    }
  ];
}
